// extracted by mini-css-extract-plugin
export default {"branding-store-button":"storeButtons_branding-store-button__U2tx6"};